import { INPUT_NAMES } from '../components/Form/Form.constants';

export const TRACKING = {
  EVENTS: {
    [INPUT_NAMES.TERM]: INPUT_NAMES.TERM,
    [INPUT_NAMES.DOWN_PAYMENT]: INPUT_NAMES.DOWN_PAYMENT,
    [INPUT_NAMES.PHONE]: INPUT_NAMES.PHONE,
    [INPUT_NAMES.PURCHASE_INTENT]: INPUT_NAMES.PURCHASE_INTENT,
    PRIVACY_LINK: 'privacyLink',
    TERMS_LINK: 'termsLink',
    SUBMIT: 'submit',
  },
};

export const TrackingCategory = {
  EXTERNAL_AUTO_PAGE: 'public autofin | external auto information',
};

export const TrackingEventName = {
  EXTERNAL_AUTO_PAGE: 'publicAutofin_externalAutoInformation',
};

export const TrackingEventsMap = {
  [TRACKING.EVENTS[INPUT_NAMES.DOWN_PAYMENT]]: {
    action: 'downpayment',
    label: 'value',
    interaction: '',
  },
  [TRACKING.EVENTS[INPUT_NAMES.PURCHASE_INTENT]]: {
    action: 'purchase intent',
    label: 'value',
    interaction: '',
  },
  [TRACKING.EVENTS[INPUT_NAMES.TERM]]: {
    action: 'terms',
    label: 'value',
    interaction: '',
  },
  [TRACKING.EVENTS[INPUT_NAMES.PHONE]]: {
    action: 'phone',
    label: 'value',
    interaction: '',
  },
  [TRACKING.EVENTS.PRIVACY_LINK]: {
    action: 'privacy link',
    label: '',
    interaction: 'click',
    name: '',
  },
  [TRACKING.EVENTS.TERMS_LINK]: {
    action: 'terms and conditions link',
    label: '',
    interaction: 'click',
    name: '',
  },
  [TRACKING.EVENTS.SUBMIT]: {
    action: 'form external auto complete',
    label: 'success',
    interaction: '',
    name: '',
  },
};
